// 安全上传文件到 S3（前端不再保存任何长期 AWS 密钥）
(function (window, document) {
  'use strict';

  /**
   * 统一把前端上传配置集中写死在这一处。
   * 以后如果要切换 API Gateway 地址、桶名、目录、静态域名或超时策略，只改这里即可。
   */
  var CONFIG = {
    // API Gateway 鉴权接口地址。
    authEndpoint: 'https://tobj026afj.execute-api.us-west-1.amazonaws.com/prod/aws-upload/auth',

    // Shared originals are copied inside the existing bucket for each confirmed design.
    studioMaterializeEndpoint: 'https://ai-api.giftinone.com/studio/materialize',

    // 可选：如果将来为 Shopify 草稿预览单独部署了签名接口，可在这里填写；留空时继续使用 authEndpoint。
    previewAuthEndpoint: '',

    // 草稿预览页首次 JSON 请求被 CORS 预检拦截时，自动改用 text/plain 再尝试一次。
    // text/plain 属于 CORS 简单请求，可绕过“OPTIONS 未允许随机 shopifypreview.com 域名”的常见配置错误。
    previewSimpleRequestFallback: true,

    // S3 桶名。
    bucketName: 'giftinone',

    // 上传到桶内的固定目录。
    uploadFolder: 'orders',

    // 前端最终回填给购物车属性或订单属性的公开访问域名。
    staticBaseUrl: 'https://static.giftinone.com',

    // 带图层高清合成图由现有 Lambda 统一编码为 PNG；不得再跟随原图或低清预览后缀。
    hdOutputExtension: 'png',

    // 与 hdOutputExtension 对应的固定响应类型，供前后端约定和排查使用。
    hdOutputContentType: 'image/png',

    // 桶所在区域。
    region: 'us-west-1',

    // 如果桶仍然依赖 ACL，就保持 public-read；如果桶开启 Bucket owner enforced，则保持空字符串。
    objectAcl: '',

    // 申请上传授权的最长等待时间。超时后会明确失败并恢复界面，不再无限卡住。
    authTimeoutMs: 20000,

    // 单次上传至少允许 3 分钟；大文件会根据大小自动延长，最高不超过 15 分钟。
    minimumUploadTimeoutMs: 180000,

    // 单次上传的硬性上限，防止浏览器在异常网络中等待超过 15 分钟。
    maximumUploadTimeoutMs: 900000,

    // 上传期间连续 60 秒没有任何进度或服务器响应，则视为连接已卡死。
    uploadStallTimeoutMs: 60000,

    // 对网络错误、超时、429 和 5xx 自动重试一次；签名错误等 4xx 不盲目重试。
    retryCount: 1,

    // 重试前的基础等待时间；后续尝试按次数递增退避，避免立即重复请求。
    retryDelayMs: 1200,
  };

  /** 创建带错误代码、HTTP 状态和可重试标记的错误对象，便于统一判断是否重试。 */
  function uploadError(message, code, status, retriable) {
    var error = new Error(message || 'Upload failed');
    error.code = code || 'UPLOAD_ERROR';
    error.status = Number(status) || 0;
    error.retriable = retriable !== false;
    return error;
  }

  /** 只保留文件名本体并替换不安全字符，避免路径片段污染 S3 对象 Key。 */
  function safeFileName(name) {
    return String(name || '').replace(/\\/g, '/').split('/').pop().replace(/[^A-Za-z0-9._-]/g, '_');
  }

  /**
   * 统一拼接静态访问地址，供前端把公开 URL 回填到表单属性中。
   * 统一清理 URL 末尾的斜杠，避免后续拼接出重复的 //。
   * folderName 可选，以兼容原公开方法按指定目录生成静态地址的调用方式。
   */
  function publicUrl(name, folderName) {
    var folder = String(folderName || CONFIG.uploadFolder).replace(/^\/+|\/+$/g, '');
    return CONFIG.staticBaseUrl.replace(/\/+$/, '') + '/' +
      folder + '/' + safeFileName(name);
  }

  /** 读取 URL 查询参数；不用 URLSearchParams，以兼容较旧浏览器。 */
  function queryParameter(search, name) {
    var pairs = String(search || '').replace(/^\?/, '').split('&');
    for (var index = 0; index < pairs.length; index += 1) {
      if (!pairs[index]) continue;
      var parts = pairs[index].split('=');
      var key = parts.shift() || '';
      var value = parts.join('=');
      try {
        key = decodeURIComponent(key.replace(/\+/g, ' '));
        value = decodeURIComponent(value.replace(/\+/g, ' '));
      } catch (error) { /* 解码失败时保留原值，避免畸形参数导致整个上传流程中断。 */ }
      if (key === name) return value;
    }
    return '';
  }

  /** 在浏览器没有 location.origin 时手动拼接当前来源。 */
  function locationOrigin(location) {
    location = location || {};
    if (location.origin && location.origin !== 'null') return String(location.origin);
    return location.protocol && location.host ? location.protocol + '//' + location.host : '';
  }

  /**
   * 识别 Shopify 草稿商品预览环境。草稿商品不会使用正常的 /products/{handle}，
   * 而是使用随机 *.shopifypreview.com 域名和 /products_preview 路径。
   */
  function pageContext() {
    var location = window.location || {};
    var hostname = String(location.hostname || '').toLowerCase();
    var pathname = String(location.pathname || '');
    return {
      origin: locationOrigin(location),
      hostname: hostname,
      pathname: pathname,
      isShopifyPreview: /(^|\.)shopifypreview\.com$/.test(hostname) || pathname === '/products_preview',
      previewKeyPresent: Boolean(queryParameter(location.search, 'preview_key')),
    };
  }

  /** 草稿预览可选用单独的签名接口；未配置时保持与正式站完全相同。 */
  function resolveAuthorizationEndpoint(config, context) {
    config = config || CONFIG;
    if (context && context.isShopifyPreview && config.previewAuthEndpoint) {
      return config.previewAuthEndpoint;
    }
    return config.authEndpoint;
  }

  /** 当浏览器未提供 File.type 时，根据扩展名推断常见图片 MIME 类型。 */
  function mimeFromName(name) {
    var extension = String(name || '').split('.').pop().toLowerCase();
    var types = {
      jpg: 'image/jpeg', jpeg: 'image/jpeg', jfif: 'image/jpeg', png: 'image/png',
      webp: 'image/webp', gif: 'image/gif', avif: 'image/avif', heic: 'image/heic',
      heif: 'image/heif', tif: 'image/tiff', tiff: 'image/tiff', bmp: 'image/bmp',
      svg: 'image/svg+xml', ico: 'image/x-icon', arw: 'image/x-sony-arw',
      cr2: 'image/x-canon-cr2', nef: 'image/x-nikon-nef', dng: 'image/x-adobe-dng',
    };
    return types[extension] || '';
  }

  /** 统一不同浏览器返回的 MIME 别名，并提供安全的兜底类型。 */
  function contentType(blob, targetName) {
    var type = blob && blob.type ? String(blob.type).split(';')[0].trim().toLowerCase() : '';
    if (type === 'image/jpg' || type === 'image/pjpeg') type = 'image/jpeg';
    if (type === 'image/x-png') type = 'image/png';
    if (!type || type === 'application/octet-stream') {
      type = mimeFromName(blob && blob.name) || mimeFromName(targetName);
    }
    return type || 'application/octet-stream';
  }

  /**
   * 根据浏览器提供的 MIME 与原文件名返回原图对象扩展名。
   * 这里只决定 S3 Key；文件本身始终使用客户选择的原始 File 直传，不做转码。
   */
  function sourceExtension(file) {
    var type = contentType(file, file && file.name);
    var byType = {
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/webp': 'webp',
      'image/gif': 'gif',
      'image/avif': 'avif',
      'image/avif-sequence': 'avif',
      'image/heic': 'heic',
      'image/heic-sequence': 'heic',
      'image/heif': 'heif',
      'image/heif-sequence': 'heif',
      'image/tiff': 'tiff',
      'image/tif': 'tiff',
      'image/x-tiff': 'tiff',
      'image/bmp': 'bmp',
      'image/x-ms-bmp': 'bmp',
      'image/x-icon': 'ico',
      'image/vnd.microsoft.icon': 'ico',
      'image/jp2': 'jp2',
      'image/jxl': 'jxl'
    };
    if (byType[type]) return byType[type];

    // MIME 缺失或浏览器返回通用类型时，保留常见照片扩展名；未知格式使用 bin，
    // Lambda 仍按文件内容交给 Sharp 解码，不依赖这个后缀判断真实格式。
    var extension = String(file && file.name || '').split('.').pop().toLowerCase();
    var aliases = { jpeg: 'jpg', jpe: 'jpg', jfif: 'jpg', tif: 'tiff' };
    extension = aliases[extension] || extension;
    return /^(?:jpg|png|webp|gif|avif|heic|heif|tiff|bmp|ico|jp2|jxl)$/.test(extension)
      ? extension
      : 'bin';
  }

  /** 按固定高清输出契约生成公开地址；baseName 是不带 -hd 与扩展名的任务 ID。 */
  function hdPublicUrl(baseName) {
    var safeBaseName = safeFileName(baseName).replace(/\.+$/g, '');
    return publicUrl(safeBaseName + '-hd.' + CONFIG.hdOutputExtension);
  }

  /** 使用结构判断而非 instanceof，兼容 iframe 等不同 JavaScript 上下文中的 Blob/File。 */
  function blobLike(value) {
    return Boolean(value && Number(value.size) > 0 && typeof value.slice === 'function');
  }

  /**
   * 清理 S3 metadata 的值，避免控制字符或超长字符串导致签名失败。
   * 将现有裁剪参数转换为 S3 metadata，保持原 Lambda 的取参方式不变。
   */
  function metadata(cropData) {
    var result = {};
    if (!cropData) return result;
    Object.keys(cropData).forEach(function (key) {
      var value = cropData[key];
      if (value === undefined || value === null) return;
      value = String(value).replace(/[\u0000-\u001F\u007F]/g, ' ').trim().slice(0, 1024);
      if (value) result[key] = value;
    });
    return result;
  }

  /** 根据文件大小动态计算单次上传总超时，兼顾移动网络慢速上传和防止永久等待。 */
  function timeoutFor(blob) {
    var size = blob && Number(blob.size) > 0 ? Number(blob.size) : 0;
    var slowNetworkEstimate = size ? Math.ceil(size / 16384) * 1000 : 0;
    return Math.min(CONFIG.maximumUploadTimeoutMs, Math.max(CONFIG.minimumUploadTimeoutMs, slowNetworkEstimate));
  }

  /** 仅把网络中断、超时、限流和服务端错误标记为可重试，避免重复提交确定性 4xx。 */
  function retryStatus(status) {
    status = Number(status) || 0;
    return status === 0 || status === 408 || status === 425 || status === 429 || status >= 500;
  }

  /** 安全读取 XHR 状态，并兼容旧环境把 204 报为 1223 的情况。 */
  function statusOf(xhr) {
    try {
      var status = Number(xhr.status) || 0;
      return status === 1223 ? 204 : status;
    } catch (error) { return 0; }
  }

  /** 安全读取 XHR 响应文本，避免跨域异常再次抛错。 */
  function responseTextOf(xhr) {
    try { return String(xhr.responseText || ''); } catch (error) { return ''; }
  }

  /** 安全读取响应头；浏览器禁止访问时返回空字符串。 */
  function responseHeaderOf(xhr, name) {
    try { return xhr.getResponseHeader(name) || ''; } catch (error) { return ''; }
  }

  /** 判断请求头是否由浏览器管理，防止 Firefox/Safari 拒绝手动设置。 */
  function managedHeader(name) {
    name = String(name || '').toLowerCase();
    return /^(proxy-|sec-)/.test(name) || [
      'accept-charset', 'accept-encoding', 'access-control-request-headers',
      'access-control-request-method', 'connection', 'content-length', 'cookie', 'cookie2',
      'date', 'dnt', 'expect', 'host', 'keep-alive', 'origin', 'referer', 'te',
      'trailer', 'transfer-encoding', 'upgrade', 'via',
    ].indexOf(name) !== -1;
  }

  /** 拒绝非法名称和换行字符，避免请求头注入或浏览器抛错。 */
  function setHeaders(xhr, headers, code) {
    Object.keys(headers || {}).forEach(function (name) {
      if (managedHeader(name)) return;
      if (!/^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/.test(name) || /[\r\n]/.test(String(headers[name]))) {
        throw uploadError('The upload request contains an invalid header.', code, 0, false);
      }
      try { xhr.setRequestHeader(name, String(headers[name])); }
      catch (error) { throw uploadError(error.message, code, 0, false); }
    });
  }

  /** 发送 JSON 请求到鉴权服务，并为网络错误、取消和超时提供明确失败结果。 */
  function requestJson(options) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var complete = false;

      /**
       * 只允许鉴权请求成功结算一次，防止 readyState、timeout 等事件重复触发。
       * load、error、timeout 和 abort 在部分浏览器中可能相继到达，必须防止 Promise 重复结算。
       */
      function done(value) { if (!complete) { complete = true; resolve(value); } }

      /** 只允许鉴权请求失败结算一次，并把统一错误对象交给上层重试逻辑。 */
      function fail(error) { if (!complete) { complete = true; reject(error); } }

      // 鉴权接口返回后统一解析 JSON；非 2xx 状态会保留 HTTP 状态，供有限重试判断使用。
      xhr.onload = function () {
        var status = statusOf(xhr);
        var text = responseTextOf(xhr).replace(/^\uFEFF/, '');
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (error) { data = null; }
        if (status >= 200 && status < 300) return done(data);
        fail(uploadError(
          data && data.message ? data.message : 'HTTP ' + status + (text ? ' ' + text : ''),
          'AUTH_HTTP_ERROR', status, retryStatus(status)
        ));
      };

      // 网络层错误没有可靠 HTTP 状态，可由上层按临时故障处理。
      xhr.onerror = function () { fail(uploadError('Upload authorization network error.', 'AUTH_NETWORK_ERROR', 0, true)); };

      // 授权等待超过配置上限时终止本次请求，避免上传界面永久停留在等待状态。
      xhr.ontimeout = function () { fail(uploadError('Upload authorization timed out.', 'AUTH_TIMEOUT', 0, true)); };

      // 主动取消不应自动重试，以免客户已经离开操作流程后仍继续发起请求。
      xhr.onabort = function () { fail(uploadError('Upload authorization was cancelled.', 'AUTH_ABORTED', 0, false)); };

      try {
        xhr.open(options.method || 'POST', options.url, true);
        xhr.timeout = options.timeout || CONFIG.authTimeoutMs;
        if (options.withCredentials === true) xhr.withCredentials = true;

        // 在发送前过滤浏览器托管头和非法头，避免 Firefox/Safari 因 setRequestHeader 抛错而中断。
        setHeaders(xhr, options.headers, 'AUTH_HEADER_ERROR');

        // text/plain 回退已提前把 payload 转成字符串；标准请求则在这里统一 JSON 序列化。
        xhr.send(options.raw ? String(options.body) : JSON.stringify(options.body));
      } catch (error) {
        fail(uploadError(error.message || 'Unable to send authorization request.', 'AUTH_SEND_ERROR', 0, false));
      }
    });
  }

  /**
   * 向后端申请一次性上传授权；后端负责生成 presigned URL，前端不接触长期密钥。
   * 仅在 Shopify 预览域的 CORS 预检失败时回退到简单请求。
   */
  function requestUploadAuthorization(payload) {
    var context = pageContext();
    var endpoint = resolveAuthorizationEndpoint(CONFIG, context);

    /** 默认使用标准 JSON 请求；正式商品页面沿用原有行为。 */
    var jsonRequest = function () {
      return requestJson({ url: endpoint, headers: { 'Content-Type': 'application/json' }, body: payload });
    };

    return jsonRequest().catch(function (error) {
      // 浏览器把 CORS 失败表现为 status=0 的网络错误。仅在 Shopify 草稿预览页把这类错误
      // 转换成可识别代码，便于界面提示和后台排查，而不会误导正式站客户。
      if (!context.isShopifyPreview || !CONFIG.previewSimpleRequestFallback || Number(error.status) !== 0) throw error;

      // text/plain 是 CORS safelisted Content-Type，不会先发送 OPTIONS 预检。
      // Lambda/API Gateway 仍会收到相同 JSON 字符串作为 event.body。
      return requestJson({
        url: endpoint,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload),
        raw: true,
      }).catch(function (fallbackError) {
        // 简单请求仍没有 HTTP 状态，说明浏览器依旧阻止访问；附带页面来源便于后台定位 CORS 配置。
        if (Number(fallbackError.status) === 0) {
          var corsError = uploadError('The upload service did not allow this Shopify preview origin.', 'PREVIEW_CORS_BLOCKED', 0, false);
          corsError.pageOrigin = context.origin;
          throw corsError;
        }
        throw fallbackError;
      });
    });
  }

  /** 兼容 API Gateway 可能返回的 body 包装，并校验必须存在一次性上传 URL。 */
  function normalizeAuthorizationResponse(response) {
    var value = response || {};
    if (value.body !== undefined) {
      // API Gateway 代理集成可能把真实响应再包装在 body 字段内。
      value = typeof value.body === 'string' ? JSON.parse(value.body) : value.body;
    }
    if (!value || !value.uploadUrl) {
      throw uploadError('Authorization did not include an upload URL.', 'MISSING_UPLOAD_URL', 0, false);
    }
    return value;
  }

  /** 申请上传授权并展开 API Gateway 的 body 包装，确保后续流程拿到可用的一次性上传地址。 */
  function authorization(payload) {
    return requestUploadAuthorization(payload).then(normalizeAuthorizationResponse);
  }

  /** 使用后端返回的 presigned URL 执行真实上传，并检测总超时及长时间无进度的死连接。 */
  function signedUpload(options) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var complete = false;
      var stallTimer = null;
      var activity = false;
      var progress = typeof options.progress === 'function' ? options.progress : options.progressFn;

      /** 清除当前上传的无进度监控计时器，避免请求结束后仍触发超时回调。 */
      function clearStall() {
        if (stallTimer) window.clearTimeout(stallTimer);
        stallTimer = null;
      }

      /** 统一清理计时器和页面可见性监听，防止重复上传时累积监听器。 */
      function cleanup() {
        clearStall();
        if (document && document.removeEventListener) document.removeEventListener('visibilitychange', visibility);
      }

      /**
       * 只允许 S3 上传成功结算一次，并在返回前停止无进度监控。
       * load、error、timeout、abort 和停滞计时器可能竞争触发，complete 用于消除竞态。
       */
      function done(value) {
        if (complete) return false;
        complete = true; cleanup(); resolve(value); return true;
      }

      /**
       * 只允许 S3 上传失败结算一次，并在返回前停止无进度监控。
       * 返回布尔值供停滞分支判断是否仍需要中止 XHR。
       */
      function fail(error) {
        if (complete) return false;
        complete = true; cleanup(); reject(error); return true;
      }

      /**
       * 每次收到上传进度时重新计时；长时间无进度时主动中断死连接。
       * 服务器开始返回响应时也会重新计时，避免响应阶段被误判为停滞。
       * 后台标签页会暂停该计时，避免浏览器节流造成“连接卡死”的误判。
       */
      function refreshStall() {
        clearStall();
        activity = true;
        if (document && document.hidden) return;
        stallTimer = window.setTimeout(function () {
          if (fail(uploadError('The upload connection stopped making progress.', 'UPLOAD_STALLED', 0, true))) {
            try { xhr.abort(); } catch (error) { /* 请求可能已被浏览器关闭，无需再次处理。 */ }
          }
        }, CONFIG.uploadStallTimeoutMs);
      }

      /** 页面隐藏时暂停停滞监控，恢复可见且上传未结束时再从零开始计时。 */
      function visibility() {
        if (document.hidden) clearStall();
        else if (activity && !complete) refreshStall();
      }

      // 空的预签名 URL 属于确定性错误，不发送请求也不自动重试。
      if (!options.url) return fail(uploadError('The signed upload URL is empty.', 'MISSING_SIGNED_URL', 0, false));
      if (xhr.upload) {
        // 上传进度事件既用于更新客户界面，也用于证明连接仍有活动；99% 留给 S3 最终响应。
        xhr.upload.onprogress = function (event) {
          refreshStall();
          if (!event.lengthComputable || !event.total || typeof progress !== 'function') return;
          try { progress(Math.min(99, Math.floor(event.loaded / event.total * 100))); }
          catch (error) { console.error('Upload progress callback failed:', error); }
        };

        // 文件字节发送完毕后重新计时，给 S3 留出返回最终响应的时间。
        xhr.upload.onload = refreshStall;
      }

      // S3 已返回响应头但正文尚未完成时，也视为连接仍然活跃。
      xhr.onreadystatechange = function () {
        if (xhr.readyState >= 2 && xhr.readyState < 4 && !complete) refreshStall();
      };

      // 仅 2xx 表示 S3 接收成功，同时安全读取 ETag 和请求 ID 供诊断使用。
      xhr.onload = function () {
        var status = statusOf(xhr);
        if (status >= 200 && status < 300) {
          return done({ etag: responseHeaderOf(xhr, 'ETag'), requestId: responseHeaderOf(xhr, 'x-amz-request-id') });
        }
        fail(uploadError('S3 upload failed with status ' + status + '. ' + responseTextOf(xhr), 'UPLOAD_HTTP_ERROR', status, retryStatus(status)));
      };

      // 网络中断通常是临时故障，可交由外层有限重试。
      xhr.onerror = function () { fail(uploadError('S3 upload network error.', 'UPLOAD_NETWORK_ERROR', 0, true)); };

      // 总上传时间超过动态上限时终止本次尝试，避免永久等待。
      xhr.ontimeout = function () { fail(uploadError('S3 upload timed out.', 'UPLOAD_TIMEOUT', 0, true)); };

      // abort 可能由停滞检测触发；fail 的单次结算保护会保留最先发生的准确错误。
      xhr.onabort = function () { fail(uploadError('S3 upload was interrupted.', 'UPLOAD_ABORTED', 0, false)); };
      if (document && document.addEventListener) document.addEventListener('visibilitychange', visibility);

      try {
        xhr.open(options.method || 'PUT', options.url, true);
        xhr.timeout = options.timeout || options.timeoutMs || timeoutFor(options.blob);

        // 预签名请求头必须与后端签名一致，同时跳过浏览器禁止手动设置的托管头。
        setHeaders(xhr, options.headers, 'UPLOAD_HEADER_ERROR');
        xhr.send(options.blob);
      } catch (error) {
        fail(uploadError(error.message || 'Unable to start S3 upload.', 'UPLOAD_SEND_ERROR', 0, false));
      }
    });
  }

  /**
   * 对外保留原 uploadToS3 调用签名，并补充超时、一次重试、完整错误回调和 Promise 返回值。
   * 内部依次完成获取授权、上传 Blob 和回调最终公网 URL。
   */
  function uploadToS3(options) {
    options = options || {};
    var blob = options.blob;
    var name = safeFileName(options.fileName);
    var type = contentType(blob, name);
    var highestProgress = 0;
    // Only the exact File fetched by Studio carries this immutable provenance.
    // Choosing a new local File naturally removes it; no URL/global state is used.
    var studioPhotoId = blob && blob.gioStudioPhotoId;
    var isStudioOriginal = !!studioPhotoId && /-origin\.(?:jpe?g|png|webp)$/i.test(name);
    var materializeOperationId = null;
    if (isStudioOriginal) {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') materializeOperationId = window.crypto.randomUUID();
      else if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = window.crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        materializeOperationId = Array.from(bytes, function(value) { return value.toString(16).padStart(2, '0'); })
          .map(function(value, index) { return ([4, 6, 8, 10].indexOf(index) !== -1 ? '-' : '') + value; }).join('');
      } else return Promise.resolve(callbackError(uploadError('Please use a secure browser connection to prepare this saved photo.', 'STUDIO_SECURE_CONTEXT_REQUIRED', 0, false)));
    }

    /**
     * 调用旧版 errorFn 并隔离回调自身的异常。
     * 返回 null 可兼容只使用回调、不处理 Promise rejection 的现有 Liquid 调用方。
     */
    function callbackError(error) {
      if (typeof options.errorFn === 'function') {
        try { options.errorFn(error); } catch (callbackFailure) { console.error(callbackFailure); }
      }
      return null;
    }

    // Blob/File 采用结构判断而非 instanceof，确保 iframe 及不同浏览器上下文中的对象也能上传。
    if (!blobLike(blob)) return Promise.resolve(callbackError(uploadError('The image file is empty or unavailable.', 'MISSING_BLOB', 0, false)));

    // 文件名清理后为空属于确定性输入错误，直接交还界面，不申请无效签名。
    if (!name) return Promise.resolve(callbackError(uploadError('The upload file name is empty.', 'MISSING_FILE_NAME', 0, false)));

    // 生成对象在 S3 中的最终 Key，并固定落在可控目录下。
    // 元数据字段和 orderNotPlaced 标签继续保持现有 Lambda 的处理约定。
    var payload = {
      key: CONFIG.uploadFolder.replace(/^\/+|\/+$/g, '') + '/' + name,
      fileName: name,
      folderName: CONFIG.uploadFolder,
      contentType: type,
      metadata: metadata(options.cropData),
      tagging: 'orderNotPlaced=true',
      publicUrl: publicUrl(name),
    };

    /**
     * 保证重试过程中展示的进度只前进不倒退，减少客户误以为上传重新开始。
     * 某些浏览器会乱序派发进度事件，单调进度可避免界面百分比突然回退。
     */
    function progress(value) {
      highestProgress = Math.max(highestProgress, Math.max(0, Math.min(100, Number(value) || 0)));
      if (typeof options.progressFn === 'function') {
        try { options.progressFn(highestProgress); } catch (error) { console.error(error); }
      }
    }

    /**
     * 执行一次完整的“申请授权 + 上传文件”流程；每次重试都会重新申请 URL，避免复用过期签名。
     */
    function attempt(index) {
      var pending;
      if (isStudioOriginal) {
        progress(5);
        pending = requestJson({
          url: CONFIG.studioMaterializeEndpoint,
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
          timeout: 60000,
          body: { photoId: String(studioPhotoId), fileName: name,
            cropData: options.cropData || {}, operationId: materializeOperationId }
        }).then(function (response) {
          if (!response || response.ok !== true || typeof response.publicUrl !== 'string'
              || response.key !== payload.key || response.publicUrl !== publicUrl(name)) {
            throw uploadError('The saved photo could not be prepared for this design. Please retry.', 'STUDIO_MATERIALIZE_ERROR', 0, false);
          }
          return { publicUrl: response.publicUrl };
        }).catch(function (error) {
          if (error.status === 401 || error.status === 403 || error.status === 404 || error.status === 410) {
            error.message = 'Your saved photo is no longer available in this session. Please select your photo again.';
            error.code = 'STUDIO_PHOTO_EXPIRED';
          }
          throw error;
        });
      } else pending = authorization(payload).then(function (auth) {
        var headers = {};

        // 合并后端签名时要求的全部请求头，并确保 Content-Type 与签名值保持一致。
        // 浏览器托管头不能由脚本设置，因此需要先过滤，防止 Firefox/Safari 拒绝请求。
        Object.keys(auth.headers || {}).forEach(function (key) {
          if (!managedHeader(key)) headers[key] = String(auth.headers[key]);
        });

        // 后端未显式返回 Content-Type 时，使用申请签名时提交的 MIME。
        var hasContentType = Object.keys(headers).some(function (key) { return key.toLowerCase() === 'content-type'; });
        if (!hasContentType) headers['Content-Type'] = type;
        return signedUpload({
          url: auth.uploadUrl,
          method: auth.method || 'PUT',
          headers: headers,
          blob: blob,
          progress: progress,
        }).then(function () { return auth; });
      });
      return pending.catch(function (error) {
        // 判断当前错误是否允许自动重试，避免对签名错误、参数错误等确定性 4xx 重复请求。
        // 执行指定次数的上传尝试，并仅对可恢复错误进行有限重试。
        if (index >= CONFIG.retryCount || error.retriable === false) throw error;

        // 延迟指定毫秒数后继续，用于失败后的短暂退避重试。
        // 随后会申请一份新签名，避免瞬时网络或服务端故障造成连续失败。
        return new Promise(function (resolve) {
          window.setTimeout(resolve, CONFIG.retryDelayMs * (index + 1));
        }).then(function () { return attempt(index + 1); });
      });
    }

    return attempt(0).then(function (auth) {
      // 只有 S3 已确认成功后才报告 100%，并把最终公开 URL 回填给原 successFn。
      progress(100);
      var url = auth.publicUrl || publicUrl(name);
      if (typeof options.successFn === 'function') options.successFn(url);
      return url;
    }).catch(function (error) {
      // 附带文件名和对象 Key，便于日志定位具体失败文件，但不暴露任何长期凭证。
      error.fileName = name;
      error.objectKey = payload.key;
      console.error('Image upload failed:', error);
      // 兼容现有只使用回调、不接 Promise 的调用方：错误已通过 errorFn 交给界面处理，这里返回 null 避免未处理的 Promise rejection。
      return callbackError(error);
    });
  }

  // 暴露可复用的兼容工具，供裁剪器与旧主题代码沿用同一套命名、地址、鉴权和上传规则。
  window.GiftInOneAwsUploadAuth = {
    /** 返回配置的浅拷贝，避免外部代码直接改写上传模块内部状态。 */
    getUploadConfig: function () { return Object.assign({}, CONFIG); },

    /** 对外提供与实际上传一致的安全文件名规则，避免裁剪器和上传端生成不同对象 Key。 */
    normalizeFileName: safeFileName,

    /** 按统一静态域名、目录和安全文件名生成购物车属性中使用的公开 URL。 */
    buildPublicUrl: publicUrl,

    /** 清理并构造供现有高清图 Lambda 读取的 S3 裁剪元数据。 */
    buildUploadMetadata: metadata,

    /** 向后端申请一次性上传地址，同时处理 Shopify 草稿预览的 CORS 回退。 */
    requestUploadAuthorization: requestUploadAuthorization,

    /** 使用预签名地址直传 Blob，并执行总超时、停滞检测和事件清理。 */
    uploadWithSignedRequest: signedUpload,

    /** 根据文件大小计算有上下限的单次上传总超时时间。 */
    calculateUploadTimeoutMs: timeoutFor,

    /** 返回当前页面来源及 Shopify 草稿预览识别结果。 */
    getPageContext: pageContext,

    /** 根据 Blob 类型和目标文件名统一解析兼容的 MIME 类型。 */
    resolveContentType: contentType,

    /** 返回原始 File 对应的安全扩展名；不会读取或转换整张图片。 */
    resolveSourceExtension: sourceExtension,

    /** 按 Lambda 固定 PNG 输出契约生成高清图公开地址。 */
    buildHdPublicUrl: hdPublicUrl,

    /** 在不依赖 URLSearchParams 的情况下读取指定查询参数。 */
    getQueryParameter: queryParameter,

    /** 在旧浏览器缺少 location.origin 时返回手动拼接的页面来源。 */
    getLocationOrigin: locationOrigin,

    /** 跨 iframe/窗口判断对象是否具备可上传 Blob 的必要结构。 */
    isBlobLike: blobLike,

    /** 判断请求头是否由浏览器管理，供外部调用方在签名上传前安全过滤。 */
    isBrowserManagedHeader: managedHeader,

    /** 根据正式页或 Shopify 草稿预览环境选择对应的鉴权接口。 */
    resolveAuthorizationEndpoint: resolveAuthorizationEndpoint,
  };
  // 保留主题原有的全局方法名，现有 Liquid 代码无需改变调用方式。
  window.uploadToS3 = uploadToS3;
})(window, document);
